/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import './BoxPort.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { FormGroup, Input, Label } from 'reactstrap';
import activated from '../../../../../Res/Icon/activated.png';
import alertErrorMessageWarning from '../../../../../Res/Icon/alertErrorMessageWarning.svg';
import { checkPendingFaxes } from '../../../../../actions/Fax';
import { NUMBER_TYPES_LABEL } from '../../../../../lib/constants';
import { generateClassNames } from '../../../../../utils/generateClassNames'
import TooltipIcon from '../../TooltipIcon/TooltipIcon'
import { dialToneOnly } from '../../../constants';
const BoxPort = ({
  port,
  onPortSelect,
  selected,
  resetE911,
  assignE911ToPort,
  boxDetails,
  checkPendingFaxes,
  boxPortsStatus,
  isBoxPortsStatLoading
}) => {
  const [e911Check, setE911Check] = useState(!!port.e911Number);
  const [placement, setPlacement] = useState('right');


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1199) {
        setPlacement('top');
      } else {
        setPlacement('right');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initialize on mount

    return () => window.removeEventListener('resize', handleResize);
  }, [boxDetails,boxPortsStatus]);

  const token = localStorage.getItem('jwtToken') || null;

  const containerClassName = generateClassNames('boxPortContainer', 
    [[selected, 'selcted']
  ])

  const isPortRegistered =  (boxPortsStatus?.epikBoxRegistered && !boxPortsStatus?.ports?.[port.boxPortNumber].obiServiceStatus)
  const isWarningIcon = !isBoxPortsStatLoading && ((boxPortsStatus && !boxPortsStatus?.epikBoxRegistered) || isPortRegistered)
 

  const onPortClick = ev => {
    ev.stopPropagation();
    onPortSelect(port);
    if (port?.assignedNumberRef?.type === 'fax') {
      checkPendingFaxes(token, port?.assignedNumberRef?.number);
    }
  };

  const boxPortNumber = port?.boxPortNumber?.replace(/\s+/g, '_');
  const boxPortNumbers = port?.boxPortNumber?.replace(/\s+/g, '-');

  const expansionBoxEpis = boxDetails?.slaveBoxes[0]?.removedObis || [];
  
  const currentObi = boxDetails?.Obis?.find(
    obi => obi?.port1?.boxPortNumber === port?.boxPortNumber || obi?.port2?.boxPortNumber === port?.boxPortNumber
  );

  const expansionBoxClass = expansionBoxEpis.includes(currentObi?._id) ? 'expansionBoxEpis' : '';
  const {
    assignedNumberRef,
    callForwardBusy,
    callForwardNoAnswer,
    callForwardAlways,
    doNotDisturb,
    callWaiting,
    conferenceCall,
  } = port || {};
  
  const hasActiveFeature =
    assignedNumberRef?.isForwarded ||
    callForwardBusy?.enabled ||
    callForwardNoAnswer?.enabled ||
    callForwardAlways?.enabled ||
    doNotDisturb ||
    callWaiting ||
    conferenceCall;
  return (
    <div className={`${containerClassName} ${expansionBoxClass}`} >
      <div
        onClick={ev => {
          onPortClick(ev);
        }} 
        style={{ width: '100%' }}
      > 
        
        { 
          (port.portActivated || isWarningIcon || isBoxPortsStatLoading) &&  
          <div  className='iconsHeaderContainer'>
            <div className="portActivatedIcon">
              {port.portActivated ? (
                <TooltipIcon
                  tipId={`${boxPortNumber}_activationStatus`}
                  imgSrc={activated}
                  displayData='Port Activated'
                  placement={placement}
                  customStyle={{
                    height: '20px',
                    }}
                  customClass='portActivatedTooltip'
                />
              ) : null}
            </div>
            <div className='portWarningContainer' onClick={e => {e.stopPropagation()}} id={boxPortNumber}>
              { 
                isBoxPortsStatLoading ? <div className="loader with-custom-color">
                  Loading...
                </div> : isWarningIcon  ? 
                <TooltipIcon
                    tipId={boxPortNumber}
                    imgSrc={alertErrorMessageWarning}
                    displayData={
                    isPortRegistered ?   
                      'Port in Alarm state.' : boxPortsStatus
                    }
                    placement={placement}
                    customStyle={{
                      width: '20px',
                      height: '20px',
                      minHeight: '20px',
                      objectFit: 'contain',
                    }}
                    customClass={'port-not-registered'}
                /> : null
              }
            </div>
          </div>
        }     
       <div style={{ margin: '10px' }}>
        <div className='portLabel' id={boxPortNumbers}>{port.boxPortNumber}</div> 
        <div className="portInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="signature" />
            <h5 id="port-name-label">Port Type </h5>
          </div>
          <span id="port-name-value">
            { port?.serviceName === dialToneOnly ? NUMBER_TYPES_LABEL[port?.serviceName] :
              NUMBER_TYPES_LABEL[
                port.assignedNumberRef ? port.assignedNumberRef.type : 'unassigned'
              ]
            }
          </span>
        </div>
        <div className="portInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="hashtag" />
            <h5 id="port-number-label">Assigned Number</h5>
          </div>
          <span className="date" id="port-number-value">
            {(port.assignedNumberRef && port.assignedNumberRef.number) || 'Unassigned'}
          </span>
        </div>
        </div>
      </div>
      <div>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input
              id={`e911_enabled_${port?.boxPortNumber?.split(' ')[1]}`}
              type="checkbox"
              checked={!!boxDetails?.e911Number || !!port.e911Enabled}
              disabled
              onChange={() => {
                setE911Check(!e911Check);
                if (e911Check) {
                  resetE911(port);
                } else {
                  assignE911ToPort(port);
                }
              }}
            />
            E911 Enabled
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input type="checkbox" checked={!!port?.vmNumber || (port?.vmBox && port?.vmBox?.number)} disabled />
            Voice Mail
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
          <Input disabled type="checkbox" checked={!!hasActiveFeature} />
          {/* <Input disabled type="checkbox" checked={port?.assignedNumberRef?.isForwarded} /> */}
          Call Features
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input disabled type="checkbox" checked={port?.assignedNumberRef?.isTollFree} />
            Toll Free
          </Label>
        </FormGroup>
      </div>
    </div>
    
  );
};

const mapStateToProps = state => ({
  boxDetails: state.AppState.boxDetails.box,
});
const mapDispatchToProps = dispatch => ({
  checkPendingFaxes: (token, number) => dispatch(checkPendingFaxes(token, number)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxPort);
